import * as React from "react";
import {cx} from "emotion";

import "./header.scss";

import {cs}          from "@Common/react/chain-services";
import {Checkbox}    from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";
import {Radio}       from "@Common/ui-components/heavy/common/design2/radio/radio";
import {formatMoney} from "@Common/ui-components/language/format-money";

import {CheckShowPricing} from "../../../check-show-pricing";

export const Header = ({disabled=false, hasError, account, selected, onToggle, amount, asRadioButtons}) => {
    return (
        <div {...{
            className: cx("header-7fk", {disabled, selected, hasError}),
            onClick: () => !disabled && onToggle()
        }}>
            <div className="selected-indicator">
                {asRadioButtons ? (
                    Radio({
                        selected,
                        xdQaName: account.name,
                    })
                ) : (
                    Checkbox({
                        checked: selected,
                        xdQaName: account.name,
                    })
                )}
            </div>

            <div className="main">
                <div className="name" xd-qa-type="label" xd-qa-name={account.name}>
                    {account.name}
                </div>
                <div className="description" xd-qa-type="label" xd-qa-name={account.name+" Description"}>
                    {account.desc}
                </div>
            </div>

            {cs(
                ({}, next) => amount != null && next(),
                ({}, next) => CheckShowPricing({next}),
                () => (
                    <div className="control">
                        <div
                            className="control-static"
                            xd-qa-type="label" xd-qa-name={account.name+" Value"}
                        >
                            {formatMoney(amount, {useFreeLabel: false})}
                        </div>
                    </div>
                )
            )}
        </div>
    );
};
